const UserHome = 0;
const TimeHistory = 1;
const TimeInput = 2;
const Flyout = 3;
const Profile = 4;
const Report = 5;
const Absence = 6;
const Privacy = 7;
const Terms = 8;
const FAQ = 9;

export default { UserHome, TimeHistory, TimeInput, Flyout, Profile, Report, Absence, Privacy, Terms, FAQ };
